/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaCarouselFragment, MediaCarouselFragment, FullMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel';

/**
 * Get a single MediaCarousel by ID (base - scalars only)
 */
export const getBaseMediaCarouselById = gql`
  ${BaseMediaCarouselFragment}

  query GetBaseMediaCarouselById($id: String!, $locale: String!, $preview: Boolean) {
    mediaCarousel(id: $id, locale: $locale, preview: $preview) {
      ...BaseMediaCarouselFragment
    }
  }
`;

/**
 * Get a single MediaCarousel by ID (standard - 1 level deep)
 */
export const getMediaCarouselById = gql`
  ${MediaCarouselFragment}

  query GetMediaCarouselById($id: String!, $locale: String!, $preview: Boolean) {
    mediaCarousel(id: $id, locale: $locale, preview: $preview) {
      ...MediaCarouselFragment
    }
  }
`;

/**
 * Get a single MediaCarousel by ID (full - 2 levels deep)
 */
export const getFullMediaCarouselById = gql`
  ${FullMediaCarouselFragment}

  query GetFullMediaCarouselById($id: String!, $locale: String!, $preview: Boolean) {
    mediaCarousel(id: $id, locale: $locale, preview: $preview) {
      ...FullMediaCarouselFragment
    }
  }
`;

/**
 * Get all MediaCarousel entries with pagination (base - scalars only)
 */
export const getBaseMediaCarousels = gql`
  ${BaseMediaCarouselFragment}

  query GetBaseMediaCarousels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaCarouselOrder]
    $where: MediaCarouselFilter
    $preview: Boolean
  ) {
    mediaCarouselCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseMediaCarouselFragment
      }
    }
  }
`;

/**
 * Get all MediaCarousel entries with pagination (standard - 1 level deep)
 */
export const getMediaCarousels = gql`
  ${MediaCarouselFragment}

  query GetMediaCarousels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaCarouselOrder]
    $where: MediaCarouselFilter
    $preview: Boolean
  ) {
    mediaCarouselCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...MediaCarouselFragment
      }
    }
  }
`;

/**
 * Get all MediaCarousel entries with pagination (full - 2 levels deep)
 */
export const getFullMediaCarousels = gql`
  ${FullMediaCarouselFragment}

  query GetFullMediaCarousels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaCarouselOrder]
    $where: MediaCarouselFilter
    $preview: Boolean
  ) {
    mediaCarouselCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullMediaCarouselFragment
      }
    }
  }
`;
